type MessagesType = {
  fill: string
  width: string
  height: string
  title: string
}

function Messages(props: MessagesType) {
  const fill = props.fill || 'currentColor'
  const width = props.width || '1em'
  const height = props.height || '1em'
  const title = props.title || 'messages'

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 24 24'
    >
      <title>{title}</title>
      <g
        fill={fill}
        strokeLinecap='square'
        strokeLinejoin='miter'
        strokeMiterlimit='10'
        transform='translate(0.5 0.5)'
      >
        <path
          d='m16,2H4c-1.105,0-2,.895-2,2v8c0,1.105.895,2,2,2h1v5l7-5h4c1.105,0,2-.895,2-2V4c0-1.105-.895-2-2-2Z'
          fill='none'
          stroke={fill}
          strokeWidth='1.5'
        />
        <path
          d='m22,7v9c0,1.105-.895,2-2,2h-1s0,4,0,4l-5-4h-2'
          fill='none'
          stroke={fill}
          strokeWidth='1.5'
        />
      </g>
    </svg>
  )
}

export default Messages
